<template>
	<div class="gvf">
		<v-menu
			v-model="menu"
			:close-on-content-click="false"
			:nudge-right="40"
			transition="scale-transition"
			offset-y
			min-width="auto"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					v-model="value"
					clearable
					:tabindex="tabIndex"
					:value="value"
					:label="gridViewField.Label"
					prepend-icon="mdi-calendar"
					hide-details="auto"
					dense
					outlined
					@change="changeValue()"
					:rules="[valueRule]"
					:placeholder="dateFormat"
					v-bind="attrs"
					v-on="on"
					@click:prepend="menu = !menu"
				>
				</v-text-field>
			</template>
			<v-date-picker
				v-model="pickerDate"
				@input="menu = false"
			></v-date-picker>
		</v-menu>
		<v-checkbox
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="changeValue()"
		></v-checkbox>
	</div>
</template>
<script>
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
import projectSettingsMixin from '../../../../mixins/projectSettingsMixin';
import fieldsValidationRules from '../../../../utils/fieldsValidationRules';
import moment from 'moment';
export default {
	name: 'DateField',
	mixins: [gridFieldMixin, projectSettingsMixin],
	data() {
		return {
			menu: false,
			value: null,
		};
	},
	computed: {
		validations() {
			return fieldsValidationRules;
		},
		valueRule() {
			return this.validations.validationDateNullable(
				this.value,
				this.getDateFormatProjectSetting()
			);
		},
		pickerDate: {
			get() {
				if (!this.value) return null;
				const date = moment.utc(this.value, this.dateFormat);
				return date.isValid() ? date.format('YYYY-MM-DD') : null;
			},
			set(val) {
				this.value = moment.utc(val).format(this.dateFormat);
				this.changeValue();
			},
		},
	},
	mounted() {
		if (this.record && this.key && this.record[this.key]) {
			this.value = this.getDateFormat(this.record[this.key]);
		}
	},

	methods: {
		changeValue() {
			let recordKey;

			if (this.isNull) {
				recordKey = [{ key: this.key, value: null }];
				this.value = null;
			} else {
				if (
					this.value == null ||
					(typeof this.value === 'string' &&
						this.value.trim().length === 0)
				) {
					recordKey = [{ key: this.key, value: null }];
				} else {
					let momentValue = moment
						.utc(this.value, this.dateFormat)
						.format('YYYY-MM-DD');
					recordKey = [{ key: this.key, value: momentValue }];
				}
			}
			let itemKey = [
				{
					key: gridViewFieldsUtils.getFieldName(this.gridViewField),
					value: moment.utc(this.value).format(this.dateFormat),
				},
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
	},
};
</script>
